<script>
export default {
  name: "PayLaterForm",

  props: {
    item: Object,
    showModal: Boolean,
  },

  methods: {
    saveAllowForService() {
      this.$root.loading = true;
      const allow = {
        invoiceDetailID: this.item.invoiceDetailID,
        allowforService: this.item.allowForService,
        userName: this.$root.username,
        comment: this.item.allowForServiceComment,
      };
      this.$http
        .post(`Accounts/AllowforService`, allow)
        .then(() => {
          this.$emit(`refresh`);
          this.$root.loading = false;
          this.$emit(`closeModal`);
        })
        .catch(() => {
          this.$root.loading = false;
        });
    },
  },
};
</script>
<template>
  <tail-modal :show="showModal" dimension="md:w-1/3 w-2/3">
    <template v-slot:title>
      <h5 class="font-medium text-sm">Pay Later</h5>
    </template>
    <template v-slot:modal-body>
      <div class="w-full flex flex-wrap items-center">
        <div class="w-full p-1">
          <h5 class="font-medium text-sm">Item: {{ item.itemName }}</h5>
        </div>
        <div class="w-full p-1">
          <label for="" class="label-control">Allow</label>
          <tail-select>
            <template v-slot:field>
              <select
                v-model="item.allowForService"
                class="input-control input-sm text-xs"
              >
                <option :value="false">Pay Now</option>
                <option :value="true">Pay Later</option>
              </select>
            </template>
          </tail-select>
          <span class="text-xs font-medium capitalize">{{
            item.allowForServiceUser
          }}</span>
        </div>
        <div class="w-full p-1">
          <label for="" class="label-control">Comment:</label>
          <textarea
            v-model.trim="item.allowForServiceComment"
            name=""
            id=""
            cols="30"
            rows="3"
            class="input-control input-sm text-xs"
          ></textarea>
        </div>
      </div>
    </template>
    <template v-slot:modal-footer>
      <button
        class="btn-danger btn-sm text-xs rounded mr-6"
        @click.prevent="$emit(`closeModal`)"
      >
        Close
      </button>
      <button 
        @click.prevent="saveAllowForService"
        class="btn-primary btn-sm text-xs rounded">Save</button>
    </template>
  </tail-modal>
</template>
